import { useState } from "react";
import { Button, Center, Drawer, ScrollArea } from "@mantine/core";
import MobileFilterTitle from "./MobileFilterTitle";
import SidebarFilter from "./SidebarFilter";

const MobileFilter = ({ query, countFilterResults, totalListings }) => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Drawer
        zIndex={2147483001}
        opened={opened}
        onClose={() => setOpened(false)}
        position="bottom"
        title={<MobileFilterTitle setOpened={setOpened} />}
        padding="xs"
        size="100%"
        styles={{ title: { width: "100%" }, header: { marginBottom: 0 } }}
        withCloseButton
        closeOnClickOutside
        closeOnEscape
      >
        <ScrollArea style={{ height: "91%" }} type="always" scrollbarSize={6}>
          <SidebarFilter
            query={query}
            countFilterResults={countFilterResults}
          />
          <Center>
            <Button
              type="filled"
              color="green"
              size="lg"
              className="absolute bottom-2"
              onClick={() => setOpened(false)}
              styles={{ root: { zIndex: 100 } }}
              fullWidth
            >
              Toon {new Intl.NumberFormat("nl-NL").format(totalListings)}{" "}
              vakantiehuizen
            </Button>
          </Center>
        </ScrollArea>
      </Drawer>
      <Button
        variant="filled"
        className="mb-2 bg-gradient-to-r from-green-500 to-cyan-500"
        onClick={() => setOpened(true)}
        fullWidth
      >
        Zoekfilters tonen
      </Button>
    </>
  );
};

export default MobileFilter;
